import ApiService from './ApiService';
import AuthService from './AuthService';

class FaqService extends ApiService {
    constructor(authService) {
        super();
        this._authService = authService;
        this._locale = 'ua';
        this._faqUrl = '/faq';
        this._getFaqDepartments = '/help/departments';
        this._faqHelpMe = '/messages/help';
        this._authMe = '/auth/me';
    }

    getBaseHeaders() {
        const langHeader = this._locale ? {'X-Localization' : this._locale} : {};
        const authHeader = this._authService.getAuthHeader();

        return {...authHeader, ...langHeader};
    }
    getFaq() {
        return this.getResource(this._faqUrl, {headers: this.getLangHeader()});
    }
    getFaqDepartments() {
        return this.getResource(this._getFaqDepartments,  this.getBaseHeaders());
    }
    getUser() {
        return this.postResource(this._authMe,  this.getBaseHeaders());
    }
    sendHelp(params) {
        return this.postResource(this._faqHelpMe, params, this.getBaseHeaders());
    }
}

const service = new FaqService(AuthService);

export default service;
